import { gql, TypedDocumentNode } from "@apollo/client";
import { City } from "../type";

export const SearchItem = gql`
  query posSimilaritySearch($request: PosSimilaritySearchRequest!) {
    posSimilaritySearch(request: $request) {
      value
      rate
      metadata
    }
  }
`
